























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTable from '@/components/datatable.vue';

export interface DataTableFilter {
	label: string;
	field: string;
	value: any;
	type: 'checkboxes' | 'checkbox' | 'select';
	multiple?: boolean;
	options?:
		| string[]
		| Array<{
				text: string;
				value: any;
		  }>;
}

@Component({
	components: {
		DataTable,
	},
})
export default class DataTableWithFilters extends Vue {
	@Prop(Object)
	public readonly state?: DataTableState;

	@Prop(Object)
	public readonly searchBy?: { value: string };

	@Prop(Function)
	public readonly provider?: () => void;

	@Prop(String)
	public readonly id?: string;

	@Prop(Boolean)
	public readonly disableSearchText?: boolean;

	@Prop(Function)
	public readonly clickTable?: (item: any, newtab: boolean, index: number, e: Event) => void;

	@Prop(Array)
	public readonly filters?: any;

	@Prop(Boolean)
	public readonly searchByDropdown?: boolean;

	@Prop(String)
	public readonly rowIdField?: string;

	@Prop({
		type: Array,
		default: () => {
			return [
				{ value: 'custom', label: 'Search all fields' },
				{ value: 'vatId', label: 'Search Vat Id only' },
			];
		},
	})
	public readonly searchByOptions!: { value: string; label: string }[];

	public filterCaret = true;

	public smallScreen = window.innerWidth;

	@Watch('$route.query.search')
	public searchChange() {
		const searchQuery = this.$route?.query?.search;

		if (searchQuery == null) return;

		if (this.state) {
			this.state.search = `${searchQuery}`;
			this.reload();
		}
	}

	@Watch('smallScreen')
	public filterChange() {
		this.filterCaret = this.smallScreen > 1000;
	}

	public created() {
		window.addEventListener('resize', this.myEventHandler);
		this.filterChange();
		this.searchChange();
	}
	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}
	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', this.id);
	}

	public checkEnter(event) {
		if (event.which === 13) {
			this.reload();
		}
	}
}
